import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Layout from "components/structure/Layout";
import React, { useCallback, useEffect, useState } from "react";
import { Button, CircularProgress, Grid, IconButton, InputAdornment } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthData } from "auth/AuthWarpper";
import DataTable from "utils/DataTable/DataTable";
import NoData from "assets/noData.svg";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { SnackbarContext } from "context/snackBarContext";
import ImportService from "services/ImportService";
import CustomPagination from "../Common/CustomPagination";
import iconSearchs from "../../../../../src/assets/iconSearchs.svg"
import docEnabled from "assets/docEnabled.svg";

const columns = [
  {
    field: "fa-bat-one-id",
    headerName: "FA Bat One ID",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "ft-bat-one-id",
    headerName: "FT Bat One ID",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "location-code",
    headerName: "Location Code",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "location-name",
    headerName: "Location Name",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "import-status",
    headerName: "Upload Status",
    flex: 1,
    headerAlign: "left",
    align: "left",
    renderCell: (params) => (
      <span style={{ color: params.value === "Fail" ? "red" : "green" }}>
        {params.value}
      </span>
    ),
  },
  {
    field: "mapped",
    headerName: "Mapped",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
  {
    field: "error-description",
    headerName: "Error Description",
    flex: 1,
    headerAlign: "left",
    align: "left",
  },
];

const ViewFTLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = AuthData();
  const params = useParams();
  const { id } = params;
  const dataPrev = location.state;
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(5);
  const [data, setData] = useState([]);
  const [value, setValue] = useState("");
  const {
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);
  const [searchInput, setSearchInput] = React.useState(null);
  const [userInput, setUserInput] = useState('')

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const paginate = (pageNumber, itemsPerPage) => {
    callHierarchyAPI(pageNumber - 1, itemsPerPage);
  };

  useEffect(() => {
    callHierarchyAPI(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage, value]);

  const callHierarchyAPI = (pNumber, size, searchquery) => {
    setLoading(true);
    let query = {
      id: id,
      pageNumber: pNumber,
      size: size,
      status: value ? value == "All" ? "" : value : undefined,
    };
    if (searchquery) {
      query.keyword = searchquery
    }
    ImportService.FetchAllFTtoFAViewLog(query)
      .then((res) => {
        setCurrentPage(pNumber);
        setItemsPerPage(size);
        let rows = res?.data?.response?.importFTFAMappinglogs;
        let newRows = rows.map(row => ({
          ...row,
          ftfamappingLogId: row['ft-fa-mapping-log-id']
        }));
        setData(newRows);
        setTotalItems(res?.data?.response?.totalItems);
      })
      .catch((error) => {
        setData([]);
        setMessage(error?.response?.data?.message || error?.message)
        setOpenAlert(true)
        setSeverity("error")
        console.error("API call failed:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleExportAll = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'text' // Expecting the response as plain text (CSV content)
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const BOM = '\uFEFF'; // UTF-8 BOM
      const fileContent = BOM + response.data;
      // Create a Blob from the text content

      const blob = new Blob([fileContent], { type: 'text/csv;charset=utf-8;' }); // Ensure MIME type is 'text/csv'
      // Create a URL for the Blob and trigger a download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv'; // Set the file name for download
      document.body.appendChild(a); // Append the anchor to the document
      a.click(); // Trigger the download
      document.body.removeChild(a); // Remove the anchor from the document
      window.URL.revokeObjectURL(url); // Clean up the object URL
    } catch (error) {
      console.error('Error downloading file:', error);
      // Handle the error (e.g., show a message to the user)
    }
  };

  // Example for Base64 data
  const decodeBase64 = (base64String) => {
    const binaryString = window.atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return new Blob([bytes], { type: 'application/octet-stream' });
  };

  const handleExportAllwithbase64 = async () => {
    try {
      const response = await ImportService.ExportAll({ ilHeaderId: id }, {
        responseType: 'text'
      });

      if (response.status !== 200) {
        throw new Error('Network response was not ok');
      }

      const fileContent = response.data;

      // Decode Base64 data if necessary
      const blob = decodeBase64(fileContent);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'data.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      setMessage(error?.response?.data?.message || error?.message);
      setOpenAlert(true);
      setSeverity("error");
      setLoading(false);
    }
  };

  const debounceCustom = (func, delay) => {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  const onSearch = useCallback(
    debounceCustom((searchquery, pageSize) => {
      setSearchInput(searchquery)
      if (searchquery != "") {
        const params = new URLSearchParams();
        params.append('keyword', searchquery)
        setUserInput(searchquery);
        callHierarchyAPI(0, pageSize, searchquery)
      } else {
        callHierarchyAPI(0, pageSize)
      }
    }, 1000)
  );
  const setColor = (status) => {
    switch (status) {
      case "Success":
        return "green";
      case "Failed":
        return "red";
        case "Fail":
          return "red";
      default:
        return "black";
    }
  };
  
  const checkSuccessOrFail = (status) => {
    switch (status) {
      case "Success":
        return "Successful";
      case "Failed":
        return "Failed";
        case "Fail":
        return "Failed";
      default:
        return "";
    }
  };

  
  return (
    <Layout title="Agri360 ESG Portal">
      <div style={{ paddingBottom: "140px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Heading>Import FT To Fa Mapping</Heading>
          <Button
            sx={{
              borderRadius: 100,
              minWidth: 95,
              minHeight: 44,
              background: "#102A62",
            }}
            variant="contained"
            startIcon={<KeyboardBackspaceIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
       
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 1,
          }}
        >
         
          <Box sx={{ minWidth: "321px", display: "flex", alignItems: "flex-start" }}>
            <TextField fullWidth className="user-search-input"
              placeholder="Search" variant="outlined"
              onChange={(event) => onSearch(event.target.value, itemsPerPage)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {loading && <CircularProgress size={15} />}
                    <img src={iconSearchs} />
                  </InputAdornment>
                ),
                sx: {
                  borderRadius: "30px",
                  fontStyle: "italic",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none !important"  // This removes the border
                  }
                }
              }}
            />
          </Box>
        
        </Box>
        <Box>
          {data.length !== 0 ? (
            <>
<div
            className="import-table-container"
            style={{ paddingTop: "20px" }}
          >
            <table className="import-table">
              <thead>
                <tr className="HierarchyHead">
                  <th>FA Bat One ID</th>
                  <th>FT Bat One ID</th>
                  <th>Location Code</th>
                  <th>Location Name</th>
                  <th>Upload Status</th>
                  <th>Mapped</th>
                  <th>Error description</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, index) => (
                  <tr key={index} className="import-table-row">
                    <td>{row?.['fa-bat-one-id']}</td>
                    <td>{row?.['ft-bat-one-id']}</td>
                    <td>{row?.['location-code']}</td>
                    <td>{row?.['location-name']}</td>
                    <td style={{ color: setColor(row?.['import-status']) }}>
                      {" "}
                      {checkSuccessOrFail(row?.['import-status'])}
                    </td>
                    <td>{row.mapped}</td>
                    <td> {row?.['error-description']}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
            </>
           
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={NoData} style={{ height: "100px" }} alt="No Data" />
              <p>No Data Available</p>
            </Box>
          )}
        </Box>
      </div>
      {data.length !== 0 ?
        <Box>
          <div style={{ position: "absolute", width: "96%", bottom: "70px" }}>
            <CustomPagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={(v) => setItemsPerPage(v)}
              totalItems={totalItems}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </Box> : ""}
    </Layout>
  );
};

const Heading = styled.div`
  color: rgba(115, 125, 134, 1);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
`;

const PaperContainer = styled(Paper)`
  padding: 2rem 1rem;
`;

export default ViewFTLog;
